var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-btn',{staticClass:"text-decoration-underline text-primary mr-2",attrs:{"color":"white","depressed":""},on:{"click":_vm.selectAll}},[_vm._v("Select All ")]),_c('v-btn',{staticClass:"text-decoration-underline text-primary",attrs:{"color":"white","depressed":""},on:{"click":_vm.selectNone}},[_vm._v("Unselect All")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }